// Helpers
import { useMediaQuery } from '@helpers/useMediaQuery'
import { convertUnit, getStyle, getStyleArray } from '@helpers/getStyles'

// Styles
import styles from './Box.module.sass'

// Interfaces
import { SpacingArrayData, SpacingData } from '@interfaces/spacing'
import { Colors } from '@interfaces/theme'

interface BoxProps {
  children?: React.ReactNode
  backgroundColor?: Colors | false
  padding?: SpacingArrayData
  borderRadius?: SpacingArrayData
  border?: Colors
  borderWidth?: number
  opacity?: number
  shadow?: 'xs' | 'sm' | 'md'
  overflow?: 'hidden' | 'visible'
  spacing?: SpacingData
  className?: string
  onClick?: Function
}

interface CustomStyles {
  padding?: string
  borderRadius?: string
  borderWidth?: string
  overflow?: 'hidden' | 'visible'
  marginBottom?: string
}

const Box = ({
  children,
  backgroundColor,
  padding,
  borderRadius,
  borderWidth,
  border,
  opacity = 100,
  shadow,
  overflow = 'visible',
  className = '',
  spacing,
  onClick
}: BoxProps) => {
  const isDesktop = useMediaQuery(1168)

  const customStyles: CustomStyles = {
    overflow: overflow
  }

  if (padding) {
    customStyles.padding = getStyleArray(padding, isDesktop)
  }

  if (borderRadius) {
    customStyles.borderRadius = getStyleArray(borderRadius, isDesktop)
  }

  if (spacing) {
    customStyles.marginBottom = getStyle(spacing, isDesktop)
  }

  if (borderWidth) {
    customStyles.borderWidth = convertUnit(borderWidth)
  }

  return (
    <div
      className={`
      ${backgroundColor ? styles[`bg-${backgroundColor}-${opacity}`] : ''}
      ${border ? styles[`border-${border}`] : ''}
      ${shadow ? styles[`shadow-${shadow}`] : ''}
      ${className}
  `}
      style={customStyles}
      onClick={() => {
        onClick && onClick()
      }}
      role={onClick ? 'button' : ''}
    >
      {children}
    </div>
  )
}

export default Box
